module.exports = __webpack_public_path__ + "static/media/logo.f93a034d.png";